import { Component } from 'san';
import * as _ from 'lodash';

import {
    IUser,
    IShowChatParams,
    IChatCallback,
    IChatInfo
} from 'src/models';

import auditService from 'src/services/audit.service';
import checkOrgUsersService from 'src/services/checkOrgUsers.service';
import toasterService from 'src/services/toaster.service';
import chatService from 'src/services/chat.service';

export default class Chat extends Component {
    constructor(options: any) {
        super(options);
    }

    initData(): {
        auditId: string;    // 审批id
        isShow: boolean;    // 显示
        isBusy: boolean;
        checkedUsers: IUser[]; // 选中的用户（被沟通人）
        disabledUsers?: IUser[];    // 禁止沟通的用户（工作流当前节点上的审批人）
        message: string;
        callback?: IChatCallback;
        cancelCallback?: IChatCallback;
    } {
        return {
            auditId: null,
            isShow: false,
            isBusy: false,
            checkedUsers: [],
            disabledUsers: [],
            message: '',
            callback: null,
            cancelCallback: null
        };
    }

    inited() {
    }

    // 显示沟通（外部调用）
    show(params: IShowChatParams) {
        this.data.set('isShow', true);
        this.data.set('isBusy', false);
        this.data.set('auditId', params.auditId);
        this.data.set('callback', params.callback);
        this.data.set('cancelCallback', params.cancelCallback);
        this.initDisabledUsers(params.auditId);
    }

    initDisabledUsers(auditId: string) {
        auditService.getAuditWorkflowCurrentStepPersons(auditId).then(currentStepPersons => {
            if (currentStepPersons && currentStepPersons.length) {
                const dataKey = 'disabledUsers';
                const disabledUsers = this.data.get('disabledUsers');
                this.data.splice(dataKey, [0, disabledUsers.length, ...currentStepPersons]);
            }
        });
    }

    toCheckUsers() {
        checkOrgUsersService.show({
            isMultiple: true,
            disabledUsers: this.data.get('disabledUsers'),
            callback: (users) => {
                this.checkUsers(users);
            }
        });
    }
    checkUsers(users: IUser[]) {
        if (!users.length) {
            return;
        }
        const dataKey = 'checkedUsers';
        const oldCheckedUsers = this.data.get(dataKey);
        const newCheckedUsers = _.uniqBy([...oldCheckedUsers, ...users], 'user_id');
        this.data.splice(dataKey, [0, oldCheckedUsers.length, ...newCheckedUsers]);
    }
    removeCheckedUser(event: any, user: IUser) {
        event.stopPropagation(); 
        const dataKey = 'checkedUsers';
        const checkedUsers = this.data.get(dataKey);
        const index = _.findIndex(checkedUsers, { user_id: user.user_id });
        if (-1 !== index) {
            this.data.removeAt(dataKey, index);
        }
    }

    submit() {
        if (this.data.get('isBusy')) {
            return;
        }
        const data = this.data.get();
        const disabledUserIds = _.map(data.disabledUsers, 'user_id');
        const checkedUserIds = _.map(data.checkedUsers, 'user_id');
        if (_.intersection(disabledUserIds, checkedUserIds).length) {
            toasterService.show({
                type: 'danger',
                title: '被沟通人不能是该节点的审批人'
            });
            return;
        }
        const chatInfo: IChatInfo = {
            at_user_ids: checkedUserIds,
            title: '沟通',
            message: data.message
        };
        this.data.set('isBusy', true);
        chatService.createChat(data.auditId, chatInfo).then(() => {
            if (data.callback) {
                data.callback();
            }
            this.data.set('isShow', false);
            this.data.set('isBusy', false);
        }, () => {
            this.data.set('isBusy', false);
        });
    }

    cancel() {
        this.data.set('isShow', false);
        this.data.set('checkedUsers', []);
        const cancelCallback = this.data.get('cancelCallback');
        if (cancelCallback) {
            cancelCallback();
        }
    }
}